<template>
  <div>
    <b-table
      v-if="!loading"
      striped
      borderless
      hover
      responsive
      :fields="fields"
      :items="data"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template v-slot:cell(member)="{item:{member}}">
        <div class="text-nowrap">
          <span class="mr-4"><avatar :src="profiles[member].photo" size="1.5rem" /></span> {{profiles[member].firstName}}
        </div>
      </template>
      <template #bottom-row={fields}>
        <td v-for="field in fields" :key="field.key" class="text-center font-weight-bold">
          <template v-if="field.key==='member'">
            Total:
          </template>
          <template v-else>
            {{summ(field.key)}}
          </template>
        </td>
      </template>
    </b-table>
    <div v-else class="text-center p-3">
      <b-spinner variant="primary" label="Loading..." />
    </div>
  </div>
</template>

<script>
import Avatar from '@/components/common/Avatar'

export default {
  name: 'KeyMetrics',

  props: {
    data: {
      type: Array,
      default: () => ([])
    },

    profiles: {
      type: Object,
      default: () => ({})
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      sortBy: 'kudos',
      sortDesc: false,
      fields: [
        { key: 'member', label: '', sortable: false, class: 'text-left' },
        { key: 'kudos', label: 'Kudos received', sortable: true, class: 'text-center' },
        { key: 'internal', label: 'Internal', sortable: true, class: 'text-center' },
        { key: 'external', label: 'External', sortable: true, class: 'text-center' },
        { key: 'sent', label: 'Sent', sortable: true, class: 'text-center' },
        { key: 'softSkills', label: 'Soft skills', sortable: true, class: 'text-center' },
        { key: 'hardSkills', label: 'Hard skills', sortable: true, class: 'text-center' }
      ]
    }
  },

  methods: {
    summ(field) {
      return this.data.reduce((out, val) => out + (val[field] || 0), 0)
    }
  },

  components: {
    Avatar
  }
}
</script>
